/* lv-raty (25.09.2026): widget rat 0% PayU. Kontenery [data-lv-raty] renderuje snippet lv-payu-raty.
   Skrypt PayU ładujemy dopiero, gdy na stronie jest kontener. Koszyk: po każdej zmianie (mini koszyk
   i /cart przerysowują sekcje) widget tworzymy od nowa z aktualną kwotą z /cart.js. */
(function () {
  var SRC = 'https://static.payu.com/res/v2/widget-mini-installments.js';
  var ladowanie = null;
  function payu() {
    if (window.OpenPayU && OpenPayU.Installments) return Promise.resolve();
    if (ladowanie) return ladowanie;
    ladowanie = new Promise(function (ok, blad) {
      var s = document.createElement('script'); s.src = SRC; s.async = true;
      s.onload = function () { ok(); }; s.onerror = blad; document.head.appendChild(s);
    });
    return ladowanie;
  }
  function zl(gr) { return (gr / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function rysuj(box, kwotaGr) {
    var w = box.querySelector('.lv-raty__widget');
    var prog = box.querySelector('.lv-raty__prog');
    var min = +box.dataset.min || 30000;
    if (prog) {
      prog.hidden = kwotaGr >= min;
      var brak = prog.querySelector('[data-lv-raty-brak]');
      if (brak) brak.textContent = zl(Math.max(0, min - kwotaGr));
    }
    if (!w || box.dataset.key === '__KEY__') return;   // brak klucza PayU = tylko podpowiedź progu
    w.innerHTML = '';
    if (kwotaGr < min) return;
    /* PayU pokazuje najniższą ratę ze WSZYSTKICH planów (także oprocentowanych, np. 10,04 zł przy 379 zł),
       co obok "Raty 0%" wprowadza w błąd. Widget zostaje ukryty, a my piszemy ratę 0% (kwota / max rat 0%);
       link "plany spłaty" otwiera okno PayU z RRSO i przykładem reprezentatywnym (openWidget). */
    var maxRat = +box.dataset.maxRat || 10;
    var tekst = box.querySelector('.lv-raty__tekst');
    if (!tekst) {
      tekst = document.createElement('span'); tekst.className = 'lv-raty__tekst'; tekst.hidden = true;
      w.parentNode.insertBefore(tekst, w);
    }
    w.classList.add('lv-raty__widget--ukryty');
    payu().then(function () {
      return OpenPayU.Installments.miniInstallment('#' + w.id, {
        creditAmount: kwotaGr / 100, posId: box.dataset.pos, key: box.dataset.key,
        showLongDescription: false, lang: 'pl', currencySign: 'PLN'
      });
    }).then(function (res) {
      if (!res || !res.isWidgetAvailable) { tekst.hidden = true; box.classList.remove('lv-raty--gotowe'); return; }
      var rata = Math.ceil(kwotaGr / maxRat) / 100;
      tekst.innerHTML = '<strong>' + maxRat + ' rat 0% po ' + rata.toFixed(2).replace('.', ',') + ' zł</strong> <button type="button" class="lv-raty__link">Sprawdź plany spłaty</button>';
      tekst.hidden = false; box.classList.add('lv-raty--gotowe');
      tekst.querySelector('.lv-raty__link').addEventListener('click', function () { res.openWidget(); });
    }).catch(function (e) { console.warn('[lv-raty]', e && e.toString()); });
  }
  function wszystkie() {
    document.querySelectorAll('[data-lv-raty]').forEach(function (box) {
      if (box.dataset.lvRatyDone === box.dataset.kwota) return;
      box.dataset.lvRatyDone = box.dataset.kwota;
      rysuj(box, +box.dataset.kwota || 0);
    });
  }
  function koszyk() {
    var boxy = document.querySelectorAll('.lv-raty--koszyk[data-lv-raty]');
    if (!boxy.length) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      boxy.forEach(function (box) { box.dataset.kwota = c.total_price; box.dataset.lvRatyDone = c.total_price; rysuj(box, c.total_price); });
    }).catch(function () {});
  }
  var czekaj = null;
  new MutationObserver(function () { clearTimeout(czekaj); czekaj = setTimeout(function () { wszystkie(); }, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
  ['cart:updated', 'cart:refresh', 'cart-drawer:open', 'on:cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(koszyk, 300); });
  });
  var f = window.fetch;
  window.fetch = function (u) {
    var p = f.apply(this, arguments);
    try { if (/\/cart\/(add|change|update|clear)/.test(typeof u === 'string' ? u : u.url)) p.then(function () { setTimeout(koszyk, 400); }); } catch (e) {}
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wszystkie); else wszystkie();
})();
